export enum ThemeMessageSubject {
    ltiLoaded = "verity.lti.loaded",
    themeExists = "verity.theme.exists"
}